"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Section_1 = require("../Section");
var Select_1 = require("../Select");
var styles_1 = require("./styles");
var renderSelectComponent = function (_a) {
    var label = _a.label, name = _a.name, value = _a.value, options = _a.options, version = _a.version, onChange = _a.onChange;
    return (react_1.default.createElement(styles_1.InputWrapper, null,
        react_1.default.createElement(Select_1.Select, { label: label, name: name, options: options, value: value, onChange: function (event) {
                var _a;
                var value = event.target.value;
                var data = options.find(function (item) { return item.value === value; });
                onChange((_a = {},
                    _a[event.target.name] = {
                        version: version,
                        data: data,
                    },
                    _a));
            } })));
};
exports.CompanyInfoSection = function (_a) {
    var _b = _a.metadataOptions, metadataOptions = _b === void 0 ? {} : _b, _c = _a.exportedMetadata, exportedMetadata = _c === void 0 ? {} : _c, animationIndex = _a.animationIndex, onChange = _a.onChange;
    return (react_1.default.createElement(Section_1.Section, { title: "Company information", animationIndex: animationIndex },
        react_1.default.createElement(react_1.default.Fragment, null,
            renderSelectComponent({
                label: 'Industry',
                name: 'industry',
                value: exportedMetadata.industry && exportedMetadata.industry.data
                    ? exportedMetadata.industry.data.value
                    : null,
                options: metadataOptions.industries.data || [],
                version: metadataOptions.industries.version,
                onChange: onChange,
            }),
            renderSelectComponent({
                label: 'Revenue',
                name: 'revenue',
                value: exportedMetadata.revenue && exportedMetadata.revenue.data
                    ? exportedMetadata.revenue.data.value
                    : null,
                options: metadataOptions.revenues.data || [],
                version: metadataOptions.revenues.version,
                onChange: onChange,
            }),
            renderSelectComponent({
                label: 'Number of employees',
                name: 'employeesNumber',
                value: exportedMetadata.employeesNumber &&
                    exportedMetadata.employeesNumber.data
                    ? exportedMetadata.employeesNumber.data.value
                    : null,
                options: metadataOptions.employeesNumberBands.data || [],
                version: metadataOptions.employeesNumberBands.version,
                onChange: onChange,
            }),
            renderSelectComponent({
                label: 'Head office location',
                name: 'headOfficeLocation',
                value: exportedMetadata.headOfficeLocation &&
                    exportedMetadata.headOfficeLocation.data
                    ? exportedMetadata.headOfficeLocation.data.value
                    : null,
                options: metadataOptions.headOfficeLocations.data || [],
                version: metadataOptions.headOfficeLocations.version,
                onChange: onChange,
            }))));
};
exports.CompanyInfoSection.propTypes = {
    animationIndex: prop_types_1.default.number.isRequired,
    onChange: prop_types_1.default.func.isRequired,
};
//# sourceMappingURL=index.js.map